<template>
  <div class="contain">
    <!-- 第一部分 -->
    <el-card class="box-card card-a">
      <div slot="header" class="clearfix" style="display: flex">
        <div style="height: 2.5rem" class="tab1">客户信息</div>
      </div>
      <div>
        <el-row>
          <el-col :span="24">
            <div class="choose">
              <div style="display: flex">
                <el-input v-model="projectName" placeholder="选择项目"></el-input>
                <el-button type="primary" style="margin-left: 1.25rem; height: 2.5rem"
                  @click="chooseProject">选择</el-button>
              </div>
              <div>
                <el-button type="danger" icon="el-icon-circle-plus-outline" @click="addNode">添加节点</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="cunstomInfo">
        <el-row>
          <el-col :span="8"> 项目名称：{{ projectInfo.projectName }} </el-col>
          <el-col :span="8">立项时间：<span v-if="projectInfo.createDt">{{
            projectInfo.createDt | dataFormatT
          }}</span>
          </el-col>
          <el-col :span="8">结项时间：<span v-if="projectInfo.conclusionTime">{{
            projectInfo.conclusionTime | dataFormatT
          }}</span></el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            商务：{{ projectInfo.businessDirectorName }}
          </el-col>
        </el-row>
      </div>
    </el-card>
    <!-- 第二部分 -->
    <el-card class="box-card card-b">
      <div slot="header" class="clearfix" style="display: flex">
        <div style="height: 2.5rem" class="tab1">项目节点</div>
      </div>
      <div class="step">
        <el-steps>
          <el-step v-for="(item, index) in stepList" :key="index" :title="item.expectFinishTime | dataFormatT"
            :description="item.nodeName">
            <template slot="description">
              <span>{{ item.nodeName }} <br />
                {{ item.leaderRemark }}</span>
            </template>
          </el-step>
        </el-steps>
      </div>
    </el-card>
    <!-- 第三部分 -->
    <div v-if="projectInfo.projectName != ''">
      <el-card class="box-card card-c" v-for="(item, index) in stepList" :key="index">
        <div slot="header" class="clearfix" style="display: flex">
          <div style="height: 2.5rem" class="tab1">{{ item.nodeName }}</div>
        </div>
        <div>
          <div class="todo">
            <el-button type="primary" icon="el-icon-check" @click="saveNode(item, index)"></el-button>
            <el-button type="danger" icon="el-icon-delete" @click="deleteNode(item.nodeCode)"></el-button>
          </div>
          <el-form ref="form" :model="form" label-width="9.375rem">
            <el-row>
              <el-col :span="8">
                <el-form-item label="节点名称：">
                  <el-input placeholder="请输入节点名称" v-model="item.nodeName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="预计完成时间：">
                  <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="item.expectFinishTime"
                    type="date" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="责任人名称：">
                  <el-input placeholder="请输入责任人名称" v-model="item.nodeLeaderName"></el-input>
                  <p class="chooseMember" @click="chooseMember(index)">选择</p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="节点成员：">
                  <!-- <div v-if="item.projectNodesMemberList.length == 0">
                    <el-input placeholder="节点成员"></el-input>
                  </div> -->
                  <div v-for="(member, i) in item.projectNodesMemberList" :key="i">
                    <div class="memberBox">
                      <el-input readonly="true" placeholder="节点成员" v-model="member.nodeMemberName"></el-input>
                      <p class="chooseMember" @click="chooseMemberTwo(index, i)">
                        选择
                      </p>
                      <i class="el-icon-circle-plus-outline addIcon" @click="addMember(index)" v-if="i === 0"></i>
                      <i class="el-icon-remove-outline addIcon" @click="deleteMember(index, i)" v-if="i > 0"></i>
                    </div>
                  </div>
                  <!-- <div v-if="item.memberList.length == 0">
                  <el-input placeholder="节点成员"></el-input>
                </div> -->
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="备注：">
                  <el-input type="textarea" :rows="6" placeholder="请输入备注" v-model="item.leaderRemark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>

    <!-- 选择项目对话框 -->
    <el-dialog title="选择项目" :visible.sync="dialogVisible" width="50%" @close="closeChooseDia">
      <el-form :model="searchInput" label-width="5rem">
        <div style="padding: 1.25rem">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="项目名称">
                <el-input v-model="searchInput.projectName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button type="success" @click="search">查询</el-button>
            </el-col>
          </el-row>
          <div style="height: 450px">
            <el-scrollbar style="height: 90%; width: 100%">
              <el-table :data="tableData" style="width: 100%" @row-click="singleElection" highlight-current-row border>
                <el-table-column align="center" width="50" label="选择">
                  <template slot-scope="scope">
                    <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                    <el-radio class="radio" v-model="templateSelection" :label="scope.row.id">&nbsp;</el-radio>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="projectName" label="项目名称">
                </el-table-column>
                <el-table-column align="center" prop="businessDirectorName" label="商务负责人">
                </el-table-column>
                <el-table-column align="center" prop="startTime" label="立项时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.createDt | dataFormatT }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="endTime" label="结项时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.conclusionTime | dataFormatT }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="pprojectTime" label="工期"></el-table-column>
              </el-table>
            </el-scrollbar>
            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="queryInfo.currPage" :page-sizes="[200, 10, 20, 30, 50]"
              :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="total"></el-pagination>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectConfirm">选 择</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 选择项目对话框 -->
    <!-- 选择责任人 -->
    <el-dialog title="选择人员" :visible.sync="dialogVisibleTwo" width="50%">
      <el-form :model="searchInput1" label-width="5rem">
        <div style="padding: 1.25rem">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="人员名称">
                <el-input v-model="searchInput1.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button type="success" @click="search1">查询</el-button>
            </el-col>
          </el-row>
          <div style="height: 450px">
            <el-scrollbar style="height: 95%; width: 100%">
              <el-table :data="tableDataTwo" style="width: 100%" @row-click="singleElectionTwo" highlight-current-row
                border>
                <el-table-column align="center" width="50" label="选择">
                  <template slot-scope="scope">
                    <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                    <el-radio class="radio" v-model="templateSelectionTwo" :label="scope.row.id">&nbsp;</el-radio>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="phone" label="登录账号">
                </el-table-column>
                <el-table-column align="center" prop="name" label="真实姓名">
                </el-table-column>
                <el-table-column align="center" prop="source" label="所属部门">
                </el-table-column>
              </el-table>
            </el-scrollbar>
            <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
              :current-page.sync="queryInfo1.currPage" :page-sizes="[200, 50, 20, 10]" :page-size="queryInfo1.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total1" next-text="下一页" prev-text="上一页">
            </el-pagination>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="leaderConfirm">选 择</el-button>
        <el-button @click="dialogVisibleTwo = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 选择责任人 -->
    <!-- 选择项目成员 -->
    <el-dialog title="选择人员" :visible.sync="dialogVisibleThree" width="50%">
      <el-form :model="searchInput2" label-width="5rem">
        <div style="padding: 1.25rem">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="人员名称">
                <el-input v-model="searchInput2.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button type="success" @click="search2">查询</el-button>
            </el-col>
          </el-row>
          <div style="height: 450px">
            <el-scrollbar style="height: 95%; width: 100%">
              <el-table :data="tableDataThree" style="width: 100%" @row-click="singleElectionThree"
                highlight-current-row border>
                <el-table-column align="center" width="50" label="选择">
                  <template slot-scope="scope">
                    <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                    <el-radio class="radio" v-model="templateSelectionThree" :label="scope.row.id">&nbsp;</el-radio>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="phone" label="登录账号">
                </el-table-column>
                <el-table-column align="center" prop="name" label="真实姓名">
                </el-table-column>
                <el-table-column align="center" prop="source" label="所属部门">
                </el-table-column>
              </el-table>
            </el-scrollbar>
            <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
              :current-page.sync="queryInfo2.currPage" :page-sizes="[200, 50, 20, 10]" :page-size="queryInfo2.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total2" next-text="下一页" prev-text="上一页">
            </el-pagination>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="memberConfirm">选 择</el-button>
        <el-button @click="dialogVisibleThree = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 选择项目成员 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardTwo: "one",
      form: {},
      date: "",
      endDate: "",
      remark: "",
      stepList: [
        {
          nodeName: "项目节点",
          expectFinishTime: "2022-1-30 00:00:00",
          name: "陈新",
          projectNodesMemberList: [
            {
              name: "陈新",
            },
          ],
          leaderRemark: "已完成",
        },
        {
          nodeName: "项目节点",
          expectFinishTime: "2022-1-30 00:00:00",
          name: "陈新",
          projectNodesMemberList: [
            {
              name: "陈新",
            },
          ],
          leaderRemark: "已完成",
        },
        {
          nodeName: "项目节点",
          expectFinishTime: "2022-1-30 00:00:00",
          name: "陈新",
          projectNodesMemberList: [
            {
              name: "陈新",
            },
          ],
          leaderRemark: "已完成",
        },
        {
          nodeName: "项目节点",
          expectFinishTime: "2022-1-30 00:00:00",
          name: "陈新",
          projectNodesMemberList: [
            {
              name: "陈新",
            },
          ],
          leaderRemark: "已完成",
        },
      ],
      projectName: "",
      formP: {},
      dialogVisible: false,
      tableData: [
        {
          id: "0001",
          projectName: "佰草园",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0002",
          projectName: "佰草园1",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0003",
          projectName: "佰草园2",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0004",
          projectName: "佰草园3",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
      ],
      //   当前选择的行的id
      templateSelection: "",
      //   当前选择的行的数据
      checkList: [],
      // 项目信息
      projectInfo: {
        projectName: "",
      },
      //   当前选择的行的id
      templateSelectionTwo: "",
      //   当前选择的行的数据
      checkListTwo: [],
      //   当前选择的行的id
      templateSelectionThree: "",
      //   当前选择的行的数据
      checkListThree: [],
      dialogVisibleTwo: false,
      tableDataTwo: [
        {
          id: "0001",
          projectName: "佰草园",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0002",
          projectName: "佰草园1",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0003",
          projectName: "佰草园2",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0004",
          projectName: "佰草园3",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
      ],
      formM: {},
      formD: {},
      tableDataThree: [
        {
          id: "0001",
          projectName: "佰草园123",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0002",
          projectName: "佰草园1",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0003",
          projectName: "佰草园2",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0004",
          projectName: "佰草园3",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
      ],
      dialogVisibleThree: false,
      // 项目表格分页
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 200,
        //查询条件
        condition: {
          id: "",
          projectName: "",
        },
      },
      // 责任人表格分页
      queryInfo1: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 200,
        //查询条件
        condition: {
          name: "",
        },
      },
      // 项目成员表格分页
      queryInfo2: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 200,
        //查询条件
        condition: {
          name: "",
        },
      },
      total: 0,
      total1: 0,
      total2: 0,
      searchInput: {},
      searchInput1: {},
      searchInput2: {},
    };
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition.projectName = this.searchInput.projectName;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    search1() {
      this.queryInfo1.condition.name = this.searchInput1.name;
      this.getMenberList();
    },
    // 监听 pagesize改变的事件
    handleSizeChange1(newSize) {
      this.queryInfo1.pageSize = newSize;
      this.getMenberList();
    },
    // 监听 页码值 改变事件
    handleCurrentChange1(newSize) {
      this.queryInfo1.currPage = newSize;
      this.getMenberList();
    },
    search2() {
      this.queryInfo2.condition.name = this.searchInput2.name;
      this.getMenberList2();
    },
    // 监听 pagesize改变的事件
    handleSizeChange2(newSize) {
      this.queryInfo2.pageSize = newSize;
      this.getMenberList2();
    },
    // 监听 页码值 改变事件
    handleCurrentChange2(newSize) {
      this.queryInfo2.currPage = newSize;
      this.getMenberList2();
    },
    // 查询项目
    getListData() {
      this.queryInfo.condition.userCode = JSON.parse(
        localStorage.getItem("userCode")
      ).value;
      this.$http.post("/project/list", this.queryInfo).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.total = res.data.data.count;
          this.queryInfo.currPage = res.data.data.currPage;
          this.tableData = res.data.data.data;
          this.dialogVisible = true;
        }
      });
    },
    changeTab(type) {
      this.cardTwo = type;
    },
    addNode() {
      let myDate = new Date();
      let y = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
      let m = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)

      if (parseInt(m / 10) === 0) {
        m = "0" + m;
      }
      let d = myDate.getDate(); //获取当前日(1-31)
      if (parseInt(d / 10) === 0) {
        d = "0" + d;
      }
      // console.log('--',m,d);
      this.stepList.push({
        actualConclusionTime: null,
        conclusionTime: null,
        controlRemark: "",
        createDt: "",
        departmentCode: "",
        departmentName: "",
        distributionTime: null,
        expectFinishTime: y + "-" + m + "-" + d,
        finishTime: "",
        id: null,
        leaderRemark: "",
        nodeCode: "",
        nodeLeaderCode: "",
        nodeLeaderName: "",
        nodeName: "项目节点",
        nodeStatus: "",
        parentNodeCode: "",
        projectApprovalTime: null,
        projectCode: this.projectInfo.projectCode,
        projectName: this.projectInfo.projectName,
        projectNodesMemberList: [
          {
            nodeMemberName: "",
            nodeMemberCode: "",
          },
        ],
        seq: null,
      });
    },
    chooseProject() {
      this.getListData();
      // this.dialogVisible = true;
    },
    // 选择项目
    singleElection(row) {
      this.templateSelection = row.id;
      this.checkList = this.tableData.filter((item) => item.id === row.id);
      console.log(`该行的id为${row.id}`, this.checkList);
    },
    // 确认选择
    selectConfirm() {
      this.projectInfo = this.checkList[0];
      this.dialogVisible = false;
      this.getStepsList();
    },
    // 关闭对话框
    closeChooseDia() {
      this.tableData = [];
      this.queryInfo.currPage = 1;
      this.queryInfo.pageSize = 200;
      this.projectName = "";
    },
    // 查询项目节点
    getStepsList() {
      let sendData = {};
      sendData.projectCode = this.checkList[0].projectCode;
      this.$http
        .post("/projectNodes/loadProjectNodes", sendData)
        .then((res) => {
          console.log(res.data.data);
          if (res.data.code == 200) {
            this.stepList = res.data.data;
            for (var i = 0; i < this.stepList.length; i++) {
              // this.stepList[i].expectFinishTime= ""
              if (this.stepList[i].projectNodesMemberList.length == 0) {
                this.stepList[i].projectNodesMemberList.push({
                  nodeMemberName: "",
                });
              }
            }
          }
        });
    },
    // 删除节点
    deleteNode(nodeCode) {
      let sendData = {};
      sendData.nodeCode = nodeCode;
      this.$http.post("/projectNodes/delete", sendData).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.getStepsList();
          this.$notify.success({
            title: "提示",
            message: "删除成功",
            showClose: true,
          });
        } else {
          this.$notify.error({
            title: "提示",
            message: res.data.message,
            showClose: true,
          });
        }
      });
    },
    // 确认节点
    saveNode(node, index) {
      console.log("jiedian", node);
      this.$http.post("/projectNodes/saveProjectNodes", node).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          // this.getStepsList();
          this.$notify.success({
            title: "提示",
            message: "保存成功",
            showClose: true,
          });
          var nodeCode = res.data.data
          this.stepList[index].nodeCode = nodeCode;
        }
      });
    },
    // 查询人员信息
    getMenberList() {
      this.$http.post("/userInfo/list", this.queryInfo1).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.total1 = res.data.data.count;
          this.queryInfo1.currPage = res.data.data.currPage;
          this.tableDataTwo = res.data.data.data;
          this.dialogVisibleTwo = true;
        }
      });
    },
    // 查询人员信息
    getMenberList2() {
      this.$http.post("/userInfo/list", this.queryInfo2).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.total2 = res.data.data.count;
          this.queryInfo2.currPage = res.data.data.currPage;
          this.tableDataThree = res.data.data.data;
          this.dialogVisibleThree = true;
        }
      });
    },
    // 打开责任人弹弹窗
    chooseMember(index) {
      this.activeNum = index;
      // this.dialogVisibleTwo = true;
      this.getMenberList();
    },
    // 选择某个责任人
    singleElectionTwo(row) {
      this.templateSelectionTwo = row.id;
      this.checkListTwo = this.tableDataTwo.filter(
        (item) => item.id === row.id
      );
      console.log(`该行的责任人为${row.id}`, this.checkListTwo);
    },
    // 确定选择责任人
    leaderConfirm() {
      this.stepList[this.activeNum].nodeLeaderName = this.checkListTwo[0].name;
      this.stepList[this.activeNum].nodeLeaderCode =
        this.checkListTwo[0].loginName;
      this.dialogVisibleTwo = false;
    },
    // 打开项目成员弹窗
    chooseMemberTwo(index, i) {
      this.activeNum2 = index;
      this.activeMember = i;
      // this.dialogVisibleThree = true;
      this.getMenberList2();
    },
    // 选择某个项目成员
    singleElectionThree(row) {
      this.templateSelectionThree = row.id;
      this.checkListThree = this.tableDataThree.filter(
        (item) => item.id === row.id
      );
      console.log(`该行的编号为${row.id}`);
    },
    // 确定选择某个成员
    memberConfirm() {
      this.stepList[this.activeNum2].projectNodesMemberList[
        this.activeMember
      ].nodeMemberName = this.checkListThree[0].name;
      this.stepList[this.activeNum2].projectNodesMemberList[
        this.activeMember
      ].nodeMemberCode = this.checkListThree[0].loginName;
      this.dialogVisibleThree = false;
    },
    // 添加成员
    addMember(index) {
      console.log("11", index);
      this.stepList[index].projectNodesMemberList.push({
        nodeMemberName: "",
      });
    },
    // 删除成员
    deleteMember(index, i) {
      console.log("11", i);
      this.stepList[index].projectNodesMemberList.splice(i, 1);
    },
  },
  created() {
    // this.queryInfo.pageSize = this.$pageSize;
    // this.getListData();
  },
};
</script>

<style lang="less" scoped>
.contain {
  padding: 10px 1.25rem;
  box-sizing: border-box;

  /deep/.el-card__header {
    padding: 0;
    border-bottom: 0.0625rem solid #409eff;
  }

  .card-a {
    .choose {
      display: flex;
      justify-content: space-between;

      /deep/.el-input__inner {
        height: 2.5rem !important;
        line-height: 2.5rem !important;
      }

      /deep/.el-button {
        height: 2.5rem;
        line-height: 2.5rem;
      }
    }

    .cunstomInfo {
      margin: 1.25rem 0;
      background-color: #f7f7f7;
      padding: 1.25rem 1.875rem;
      box-sizing: border-box;
      line-height: 2.5rem;
    }

    .tab1 {
      border: 0.0625rem solid #409eff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 1.25rem;
      box-sizing: border-box;
      color: #fff;
      background-color: #409eff;
    }
  }

  .card-b {
    margin-top: 1.25rem;

    .tab1 {
      border: 0.0625rem solid #409eff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 1.25rem;
      box-sizing: border-box;
      color: #fff;
      background-color: #409eff;
    }

    .step {

      // white-space: nowrap;
      // overflow-y: auto;
      /deep/.el-step__head.is-wait {
        color: #409eff;
        border-color: #409eff;
      }

      /deep/.el-step__title.is-wait {
        color: #000;
      }

      /deep/.el-step__description.is-wait {
        color: #000;
      }

      /deep/.el-step__line {
        background-color: #409eff;
      }
    }
  }

  .card-c {
    margin-top: 1.25rem;

    .tab1 {
      border: 0.0625rem solid #409eff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 1.25rem;
      box-sizing: border-box;
      color: #fff;
      background-color: #409eff;
    }

    .chooseMember {
      position: absolute;
      top: 0.625rem;
      color: red;
      font-size: 0.75rem;
      cursor: pointer;
    }

    .todo {
      display: flex;
      justify-content: flex-end;
    }

    .memberBox {
      position: relative;

      .addIcon {
        position: absolute;
        top: 8px;
        margin-left: 10px;
        font-size: 18px;
        color: #409eff;
      }

      /deep/.el-input--small .el-input__inner {
        margin-bottom: 15px;
      }
    }
  }

  /deep/.el-button {
    border-radius: 0;
  }

  /deep/.el-dialog__header {
    background-color: #fff;
    padding: 0.625rem;
    border-top-left-radius: 0.125rem;
    border-top-right-radius: 0.125rem;
    border-bottom: 0.0625rem solid #efefef;
  }

  /deep/.el-dialog__header .el-dialog__title {
    line-height: 1.25rem;
    font-size: 1rem;
    color: #000;
  }
}
</style>